import { User } from '@esg/esg-global-types';
import React, { createContext, useEffect, useState } from 'react';
import { setAnalyticsUser } from '../lib/app/analytics/ga';

interface ContextProps {
  user: User | null;
  setUser: (user: User | null) => void;
  authenticated: boolean | null;
  setAuthenticated: (authenticated: boolean | null) => void;
}

export const UserContext = createContext<ContextProps>({
  user: null,
  authenticated: null,
  setUser: () => null,
  setAuthenticated: () => null
});

const UserContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  // Sync analytics user.
  useEffect(() => {
    setAnalyticsUser(user);
  }, [user]);

  const value = {
    user,
    setUser,
    authenticated,
    setAuthenticated
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContextProvider;
